import { FC, MouseEvent, ReactElement } from 'react';
import cn from 'classnames';

type PropsType = {
  name: string | ReactElement;
  disabled?: boolean;
  onClick?: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
  className?: string;
  startIcon?: any;
  endIcon?: any;
  type?: 'button' | 'submit' | 'reset';
  href?: string;
  target?: '_blank';
  style?: { [key: string]: string };
};

const Button: FC<PropsType> = (props) => {
  const { name, className, startIcon, endIcon, onClick, disabled, ...rest } = props;

  const Tag = rest.href ? 'a' : 'button';

  const handleClick = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    if (!disabled && onClick) return onClick(event);
    event.preventDefault();
  };

  return (
    <Tag disabled={disabled} className={cn('btn', className)} onClick={handleClick} {...rest}>
      {startIcon && <span className="btn_icon btn_icon-start">{startIcon}</span>}
      <span className="btn-text">{name}</span>
      {endIcon && <span className="btn_icon btn_icon-end">{endIcon}</span>}
    </Tag>
  );
};

export default Button;

Button.defaultProps = {
  disabled: false,
  onClick: (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => ''
};
